import * as fabric from 'office-ui-fabric-react';
import { FC, useMemo } from 'react';
import { ticketState } from '../../../enums';
import { oneFieldRow } from '../Helpers';
import { IServiceStatistic } from '../model';
import { useTickets } from './context/TicketsContext';

interface IWaitingServiceStatisticViewProps {
    services: IServiceStatistic[] | null;
}

const WaitingServiceStatisticView: FC<IWaitingServiceStatisticViewProps> = (props: IWaitingServiceStatisticViewProps) => {
    const { allTickets, waitingTickets } = useTickets();

    const nonValidTicketStates: number[] = [ticketState.Deleted, ticketState.Removed, ticketState.Stopped];

    const services = useMemo(() => {
        const services =
            props.services?.map((x) => ({
                ...x,
                count: waitingTickets.filter((t) => t.serviceId?.toString() === x.id).length
            })) || [];

        return services
            .map((x) => ({
                ...x,
                count: x.count + services.filter((s) => x.id === `${s.groupId}*`).reduce((prev, curr) => prev + curr.count, 0)
            }))
            .toSorted((a, b) => a.name.localeCompare(b.name));
    }, [waitingTickets, props.services]);

    return (
        <fabric.Stack.Item styles={{ root: { paddingTop: '2vw', paddingBottom: '2vw' } }}>
            <fabric.Stack styles={oneFieldRow} horizontal>
                <fabric.Text
                    variant={'large'}
                    style={{
                        marginBottom: '2px',
                        fontWeight: 'bold'
                    }}
                >
                    Laukia iš viso:
                </fabric.Text>
                <fabric.Text variant={'large'}>{allTickets.filter((x) => !nonValidTicketStates.includes(x.state)).length}</fabric.Text>
            </fabric.Stack>

            {services
                .filter((x) => x.groupId == null)
                .map((x: any, index: number) => (
                    <div key={`${index}`}>
                        {services!.filter((q) => q.groupId == x.id.replace('*', '')).length > 0 ? (
                            <details>
                                <summary style={{ display: 'flex', alignItems: 'center' }}>
                                    <fabric.Stack styles={oneFieldRow} horizontal>
                                        <fabric.Text variant={'large'}>{index + 1}</fabric.Text>
                                        <fabric.Text
                                            variant={'large'}
                                            style={{
                                                flex: 1,
                                                textAlign: 'left',
                                                marginLeft: '5px',
                                                marginRight: '5px',
                                                width: '260px',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {` - ${x.name}`}
                                        </fabric.Text>
                                        <fabric.Text variant={'large'}>{x.count}</fabric.Text>
                                    </fabric.Stack>
                                </summary>
                                {services!
                                    .filter((q) => q.groupId == x.id.replace('*', ''))
                                    .map((q: any, qindex: number) => (
                                        <fabric.Stack key={`${q.id}`} style={{ marginLeft: '15px' }} styles={oneFieldRow} horizontal>
                                            <fabric.Text variant={'large'}>
                                                {index + 1}.{qindex + 1}
                                            </fabric.Text>
                                            <fabric.Text
                                                variant={'large'}
                                                style={{
                                                    flex: 1,
                                                    textAlign: 'left',
                                                    marginLeft: '5px',
                                                    marginRight: '5px',
                                                    width: '260px',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {` - ${q.name}`}
                                            </fabric.Text>
                                            <fabric.Text variant={'large'}>{q.count}</fabric.Text>
                                        </fabric.Stack>
                                    ))}
                            </details>
                        ) : (
                            <fabric.Stack style={{ marginLeft: '15px' }} styles={oneFieldRow} horizontal>
                                <fabric.Text variant={'large'}>{index + 1}</fabric.Text>
                                <fabric.Text
                                    variant={'large'}
                                    style={{
                                        flex: 1,
                                        textAlign: 'left',
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        width: '260px',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    {` - ${x.name}`}
                                </fabric.Text>
                                <fabric.Text variant={'large'}>{x.count}</fabric.Text>
                            </fabric.Stack>
                        )}
                    </div>
                ))}
        </fabric.Stack.Item>
    );
};

export default WaitingServiceStatisticView;
